import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

const Label = React.forwardRef<HTMLLabelElement, AphroditeStyled<React.ComponentProps<'label'>>>(
	({ styles = [], ...props }, ref) => {
		return <label ref={ref} data-slot='label' className={css(s.label, ...styles)} {...props} />;
	}
);

Label.displayName = 'Label';

export { Label };

const s = StyleSheet.create({
	label: {
		boxSizing: 'border-box',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 14,
		lineHeight: 1,
		userSelect: 'none',
		':is([data-disabled="true"] *)': {
			pointerEvents: 'none',
			opacity: '0.5',
		},
		':is(:disabled ~ *)': {
			cursor: 'not-allowed',
			opacity: '0.5',
		},
	},
});
